export const UserVerificationKeys = {
    isUserActive: 'isUserActive',
};
